import { useEffect, useState } from "react";
import "./style.css";

function CustomSelectWeek({ value, onChange }) {
    const [weeks, setWeeks] = useState([
        {
            label: "SU",
            value: 1,
            selected: false,
        },
        {
            label: "MO",
            value: 2,
            selected: false,
        },
        {
            label: "TU",
            value: 3,
            selected: false,
        },
        {
            label: "WE",
            value: 4,
            selected: false,
        },
        {
            label: "TH",
            value: 5,
            selected: false,
        },
        {
            label: "FR",
            value: 6,
            selected: false,
        },
        {
            label: "SA",
            value: 7,
            selected: false,
        },
    ]);

    useEffect(() => {
        onChange(weeks?.filter(w => w?.selected));
    }, [weeks]);

    useEffect(() => {
        if (value) {
            let temp = [...weeks]

            for (let i = 0; i < value?.length; i++) {
                temp = temp?.map(tweek => tweek?.value == value[i]?.value ? value[i] : tweek);
            }

            setWeeks(temp);
        }

    }, []);

    return (
        <div id="custom-select-week">
            {
                weeks.map((week, index) => (
                    <div key={"csw-" + index} className={`csw-week ${week?.selected && "csw-w-selected"}`} onClick={() => {
                        setWeeks(weeks.map((w, i) => {
                            return { ...w, selected: w.value == week.value ? !week?.selected : w?.selected };
                        }));
                    }}>
                        <span>{week?.label}</span>
                    </div>
                ))
            }
        </div>
    );
}

export default CustomSelectWeek;